export enum PseTransaccionEstado {
  STATE_PENDING = "PENDIENTE",
  STATE_OK = "APROBADA",
}
